import { DailyTrendPanel } from './weekView/DailyTrendPanel';
import { DistributionPanel } from './weekView/DistributionPanel';
import { FacilityGauges } from './weekView/FacilityGauges';
import { RecoveryChasePanel } from './weekView/RecoveryChasePanel';
import { SkuLookupPanel } from './weekView/SkuLookupPanel';
import { WeekOverWeekPanel } from './weekView/WeekOverWeekPanel';

// Week tab: facility gauges, the shorts distribution, SKU lookup, the recovery chase
// list, week-over-week comparison, and the daily trend chart.
export function WeekView({
    absent,
    chase,
    curRolled,
    curWeek,
    invFor,
    locData,
    locOpen,
    lookup,
    lookupQ,
    noData,
    onExportDistribution,
    onTrendClick,
    priorKey,
    prvRolled,
    setLookupQ,
    setLookupSel,
    toggleLoc,
    trendHtml,
    trendRef,
}) {
    return (
        <>
            <FacilityGauges curRolled={curRolled} prvRolled={prvRolled} />
            <DistributionPanel
                curRolled={curRolled}
                curWeek={curWeek}
                absent={absent}
                noData={noData}
                onExport={onExportDistribution}
            />
            <SkuLookupPanel lookup={lookup} lookupQ={lookupQ} setLookupQ={setLookupQ} setLookupSel={setLookupSel} />
            {chase ? (
                <RecoveryChasePanel
                    chase={chase}
                    locOpen={locOpen}
                    locData={locData}
                    toggleLoc={toggleLoc}
                    invFor={invFor}
                />
            ) : null}
            {prvRolled ? (
                <WeekOverWeekPanel curRolled={curRolled} prvRolled={prvRolled} curWeek={curWeek} priorKey={priorKey} />
            ) : null}
            <DailyTrendPanel trendRef={trendRef} onTrendClick={onTrendClick} trendHtml={trendHtml} />
        </>
    );
}
